import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function GalleryApplyReceived() {
  const { id } = useParams();
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/gallery/applications/${id}`)
      .then((r) => setApp(r.data)).catch(() => setApp(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="p-24 text-muted2">Loading…</div>;
  if (!app) return (
    <div className="p-24 text-center">
      <div className="font-serif text-4xl">Application not found.</div>
      <Link to="/gallery/apply" className="mt-6 inline-block link-hover">Try again</Link>
    </div>
  );

  return (
    <div data-testid="apply-received" className="max-w-[900px] mx-auto px-6 md:px-12 py-16 lg:py-24">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 border flex items-center justify-center" style={{borderColor: "#4A5D4E", color: "#4A5D4E"}}>
          <CheckCircle2 size={18}/>
        </div>
        <div className="overline">Application received</div>
      </div>
      <h1 className="display text-5xl md:text-6xl mt-6">Thank you, {app.artist_name?.split(" ")[0]}.</h1>
      <p className="mt-6 text-base text-muted2 max-w-xl">
        Your application (reference <strong className="text-charcoal">{app.reference}</strong>) has been received.
        We&apos;ve emailed a confirmation to <strong className="text-charcoal">{app.email}</strong>. The gallery
        team will review and reply with confirmed dates and hall allocation. On approval, the full space fee
        will be payable within 2 weeks.
      </p>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/gallery" className="btn-ghost">Back to Gallery</Link>
        <Link to="/" className="btn-primary">Home</Link>
      </div>
    </div>
  );
}
